const getParameterByName = value => {
  const url = window.location.href
  let name = value.replace(/[[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
export default getParameterByName



// WEBPACK FOOTER //
// ./src/utils.js